import refreshEventsCount from '../actions/refreshEventsCount';
import { orchestrator } from 'satcheljs';
import { weekStartChanged } from 'mini-options-store/lib/actions/weekStart/weekStartChanged';

/**
 * Mutator to toggle the navigation mode and update the events count map
 */
export const weekStartChangedOrchestrator = orchestrator(weekStartChanged, () => {
    refreshEventsCount();
});
